// components/ForgotPassword/ForgotPassword.jsx
import React, { useState } from 'react';
import { forgotPassword } from '../../services/authService';
import './Forgotpassword.scss';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validação básica
    if (!email || !email.includes('@')) {
      setError('Por favor, insira um e-mail válido.');
      setLoading(false);
      return;
    }

    try {
      const response = await forgotPassword(email);
      
      if (response.success) {
        setSubmitted(true);
        setSuccessMessage(response.message || 'Instruções enviadas para seu e-mail!');
      } else {
        setError(response.message || 'Erro ao processar solicitação.');
      }
    } catch (err) {
      setError('Erro ao conectar ao servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__container">
        <h1 className="forgot-password__title">Recuperar Senha</h1>
        <p className="forgot-password__subtitle">
          Enviaremos um link para redefinir sua senha.
        </p>

        {submitted ? (
          <div className="forgot-password__success">
            <div className="forgot-password__success-icon">✓</div>
            <h2>E-mail enviado!</h2>
            <p>{successMessage}</p>
            <p className="forgot-password__help">
              Não recebeu o e-mail? Verifique sua caixa de spam.
            </p>
            <button 
              className="forgot-password__button"
              onClick={() => {
                setSubmitted(false);
                setEmail('');
              }}
            >
              Enviar novamente
            </button>
            <a href="/" className="forgot-password__link">
              Voltar ao login
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="forgot-password__form">
            <div className="forgot-password__field">
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                disabled={loading}
                autoFocus
              />
            </div>

            {error && (
              <div className="forgot-password__error">
                <span>⚠️</span> {error}
              </div>
            )}

            <button 
              type="submit" 
              className="forgot-password__button"
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Enviar instruções'}
            </button>

            <a href="/" className="forgot-password__link">
              ← Voltar ao login
            </a>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;